import { useMutation } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { fetchJson } from '@/lib/api';

export const useRunCycle = () => {
  const { push } = useToast();
  return useMutation({
    mutationFn: () =>
      fetchJson<{ started: boolean }>('/api/jobs/run-cycle', {
        method: 'POST',
      }),
    onError: (error: Error) => push(error.message || 'Run failed', 'error'),
  });
};
